import { render, staticRenderFns } from "./PrivacyActStatement.vue?vue&type=template&id=f6a5c9a6&scoped=true"
import script from "./PrivacyActStatement.vue?vue&type=script&lang=js"
export * from "./PrivacyActStatement.vue?vue&type=script&lang=js"
import style0 from "./PrivacyActStatement.vue?vue&type=style&index=0&id=f6a5c9a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a5c9a6",
  null
  
)

export default component.exports